import React, { Suspense, lazy } from "react";
import { createBrowserRouter, Navigate, RouterProvider } from "react-router-dom";
import PATHS from "./Paths.js";
import { useSelector } from "react-redux";
import BrandLayout from "../layouts/BrandLayout.jsx";

const Loadable = (Component) => (props) => {
  return (
    <Suspense>
      <Component {...props} />
    </Suspense>
  );
};

// Influencer Pages //
const FullLayout = Loadable(lazy(() => import("../layouts/FullLayout.jsx")));
const Signin = Loadable(lazy(() => import("../pages/auth/Signin.jsx")));
const Signup = Loadable(lazy(() => import("../pages/auth/Signup.jsx")));
const SignupInvitation = Loadable(lazy(() => import("../pages/auth/SignupInvitation.jsx")));
const SignupBasic = Loadable(lazy(() => import("../pages/auth/SignupBasic.jsx")));
const SignupPost = Loadable(lazy(() => import("../pages/auth/SignupPost.jsx")));
const SignupPackages = Loadable(lazy(() => import("../pages/auth/SignupPackages.jsx")));
const ForgotPassword = Loadable(lazy(() => import("../pages/auth/ForgotPassword.jsx")));
const ResetPassword = Loadable(lazy(() => import("../pages/auth/ResetPassword.jsx")));
const Home = Loadable(lazy(() => import("../pages/home/Home.jsx")));
const CreatorsHome = Loadable(lazy(() => import("../pages/home/CreatorsHome.jsx")));
const ContactUs = Loadable(lazy(() => import("../pages/contactus/ContactUs.jsx")));
const TermsConditions = Loadable(lazy(() => import("../pages/cmsPages/TermsConditions.jsx")));
const PrivacyPolicy = Loadable(lazy(() => import("../pages/cmsPages/PrivacyPolicy.jsx")));
const AboutUs = Loadable(lazy(() => import("../pages/cmsPages/AboutUs.jsx")));
const Influencers = Loadable(lazy(() => import("../pages/influencers/Influencers.jsx")));
const InfluencerSearch = Loadable(lazy(() => import("../pages/influencers/InfluencerSearch.jsx")));
const SavedInfluencers = Loadable(lazy(() => import("../pages/influencers/SavedInfluencers.jsx")));
const InfluencerDetail = Loadable(lazy(() => import("../pages/influencers/InfluencerDetail.jsx")));
const MarketPlace = Loadable(lazy(() => import("../pages/marketPlace/MarketPlace.jsx")));
const InfluencerSupport = Loadable(lazy(() => import("../pages/contactus/InfluencerSupport.jsx")));
const InfluencerProfile = Loadable(lazy(() => import("../pages/profile/InfluencerProfile.jsx")));
const InfluencerPublicProfile = Loadable(lazy(() => import("../pages/profile/InfluencerPublicProfile.jsx")));
const EditPackages = Loadable(lazy(() => import("../pages/profile/EditPackages.jsx")));
const Messages = Loadable(lazy(() => import("../pages/messages/Messages.jsx")));
const AddSocialLinks = Loadable(lazy(() => import("../pages/profile/SocialLinks.jsx")));
const Transactions = Loadable(lazy(() => import("../pages/transactions/Transactions.jsx")));
const ChallangeDetail = Loadable(lazy(() => import("../pages/marketPlace/ChallangeDetail.jsx")));
const YourProposals = Loadable(lazy(() => import("../pages/proposals/YourProposals.jsx")));
const YourJobs = Loadable(lazy(() => import("../pages/jobsDashboard/YourJobs.jsx")));
const ViewPitch = Loadable(lazy(() => import("../pages/proposals/ViewPitch.jsx")));
const ViewJobDetail = Loadable(lazy(() => import("../pages/jobsDashboard/ViewJobDetail.jsx")));
const JobsDashboard = Loadable(lazy(() => import("../pages/jobsDashboard/JobsDashboard.jsx")));
const JobInvitations = Loadable(lazy(() => import("../pages/jobInvitations/JobInvitations.jsx")));
const InfluencerLeaderboard = Loadable(lazy(() => import("../pages/Leaderboard/InfLeaderboard.jsx")));

// Brand Pages //
const Dashboard = Loadable(lazy(() => import("../pages/brand/dashboard/Dashboard.jsx")));
const AddChallange = Loadable(lazy(() => import("../pages/brand/challange/AddChallange.jsx")));
const ChallangeOtherDetail = Loadable(lazy(() => import("../pages/brand/challange/ChallangeOtherDetail.jsx")));
const ChallangePreview = Loadable(lazy(() => import("../pages/brand/challange/ChallangePreview.jsx")));
const ChallangePayment = Loadable(lazy(() => import("../pages/brand/challange/ChallangePayment.jsx")));
const ChallangeSuccess = Loadable(lazy(() => import("../pages/brand/challange/ChallangeSuccess.jsx")));
const Challanges = Loadable(lazy(() => import("../pages/brand/challange/Challanges.jsx")));
const Proposals = Loadable(lazy(() => import("../pages/brand/proposals/Proposals.jsx")));
const FindInfluencers = Loadable(lazy(() => import("../pages/brand/findInfluencers/FindInfluencers.jsx")));
const MyNetwork = Loadable(lazy(() => import("../pages/brand/myNetwork/MyNetwork.jsx")));
const HireInfluencers = Loadable(lazy(() => import("../pages/brand/directHire/HireInfluencers.jsx")));
const HiredInfluencers = Loadable(lazy(() => import("../pages/brand/directHire/HiredInfluencers.jsx")));
const Emails = Loadable(lazy(() => import("../pages/brand/emails/Emails.jsx")));
const Reports = Loadable(lazy(() => import("../pages/brand/reports/Reports.jsx")));
const BrandTransactions = Loadable(lazy(() => import("../pages/brand/transactions/Transactions.jsx")));
const Settings = Loadable(lazy(() => import("../pages/brand/settings/Settings.jsx")));
const BrandSupport = Loadable(lazy(() => import("../pages/brand/support/Support.jsx")));
const ViewEmail = Loadable(lazy(() => import("../pages/brand/emails/ViewEmail.jsx")));
const BrandSavedInfluencers = Loadable(lazy(() => import("../pages/brand/directHire/BrandSavedInfluencers.jsx")));
const ViewContent = Loadable(lazy(() => import("../pages/brand/directHire/ViewContent.jsx")));
const Leaderboard = Loadable(lazy(() => import("../pages/brand/leaderboard/Leaderboard.jsx")));

export default function Router() {

  const auth = useSelector((data) => data?.auth);

  const router = createBrowserRouter([
    {
      path: '/',
      element: (auth?.isLoggedIn && auth?.userDetail)
        ? (auth?.userDetail?.Role == "influencer"
          ? <FullLayout />
          : <BrandLayout />)
        : <Navigate to={PATHS.home} />
    },
    {
      path: '/signin',
      element: <Signin />
    },
    {
      path: '/',
      element: <FullLayout />,
      children: [
        { path: PATHS.home, element: <Home /> },
        { path: PATHS.creatorsHome, element: <CreatorsHome /> },
        { path: PATHS.signupBasic, element: <SignupBasic /> },
        { path: PATHS.signupPost, element: <SignupPost /> },
        { path: PATHS.signupPackages, element: <SignupPackages /> },
        { path: PATHS.contactus, element: <ContactUs /> },
        { path: PATHS.termsConditions, element: <TermsConditions /> },
        { path: PATHS.privacyPolicy, element: <PrivacyPolicy /> },
        { path: PATHS.aboutUs, element: <AboutUs /> },
        { path: PATHS.influencers, element: <Influencers /> },
        { path: PATHS.influencerSearch, element: <InfluencerSearch /> },
        { path: PATHS.savedInfluencers, element: <SavedInfluencers /> },
        { path: PATHS.influencerDetail, element: <InfluencerDetail /> },
        { path: PATHS.marketplace, element: <MarketPlace /> },
        { path: PATHS.influencerProfile, element: <InfluencerProfile /> },
        { path: PATHS.influencerPublicProfile, element: <InfluencerPublicProfile /> },
        { path: PATHS.influencerSupport, element: <InfluencerSupport /> },
        { path: PATHS.editPackages, element: <EditPackages /> },
        { path: PATHS.messages, element: <Messages /> },
        { path: PATHS.addSocialLinks, element: <AddSocialLinks /> },
        { path: PATHS.transactions, element: <Transactions /> },
        { path: PATHS.challangeDetail, element: <ChallangeDetail /> },
        { path: PATHS.yourProposals, element: <YourProposals /> },
        { path: PATHS.yourJobs, element: <YourJobs /> },
        { path: PATHS.viewPitch, element: <ViewPitch /> },
        { path: PATHS.viewJobDetail, element: <ViewJobDetail /> },
        { path: PATHS.jobsDashboard, element: <JobsDashboard /> },
        { path: PATHS.jobInvitations, element: <JobInvitations /> },
        { path: PATHS.infLeaderboard, element: <InfluencerLeaderboard /> },
      ]
    },
    {
      path: '/',
      element: <BrandLayout />,
      children: [
        { path: PATHS.dashboard, element: <Dashboard /> },
        { path: PATHS.challanges, element: <Challanges /> },
        { path: PATHS.addChallange, element: <AddChallange /> },
        { path: PATHS.challangeOtherDetail, element: <ChallangeOtherDetail /> },
        { path: PATHS.challangePreview, element: <ChallangePreview /> },
        { path: PATHS.challangePayment, element: <ChallangePayment /> },
        { path: PATHS.challangeSuccess, element: <ChallangeSuccess /> },
        { path: PATHS.brandMessages, element: <Messages /> },
        { path: PATHS.proposals, element: <Proposals /> },
        { path: PATHS.findInfluencers, element: <FindInfluencers /> },
        { path: PATHS.myNetwork, element: <MyNetwork /> },
        { path: PATHS.hireInfluencers, element: <HireInfluencers /> },
        { path: PATHS.hiredInfluencers, element: <HiredInfluencers /> },
        { path: PATHS.emails, element: <Emails /> },
        { path: PATHS.reports, element: <Reports /> },
        { path: PATHS.brandTransactions, element: <BrandTransactions /> },
        { path: PATHS.settings, element: <Settings /> },
        { path: PATHS.brandSupport, element: <BrandSupport /> },
        { path: PATHS.viewEmail, element: <ViewEmail /> },
        { path: PATHS.viewInfluencerDetail, element: <InfluencerDetail /> },
        { path: PATHS.brandSavedInfluencers, element: <BrandSavedInfluencers /> },
        { path: PATHS.viewContent, element: <ViewContent /> },
        { path: PATHS.leaderboard, element: <Leaderboard /> },
      ]
    },
    { path: '*', element: <Navigate to={PATHS.home} /> },
    { path: PATHS.signup, element: <Signup /> },
    { path: PATHS.signupInvitation, element: <SignupInvitation /> },
    { path: PATHS.forgotPassword, element: <ForgotPassword /> },
    { path: PATHS.resetPassword, element: <ResetPassword /> },
  ]);

  return <RouterProvider router={router} />;
};